<template>
<div>
  <v-data-table ref="allCompanies"
    :headers="headers"
    class="elevation-1 ex-product-table"
    hide-actions
    :items="companies"
  >
  <template
    slot="items"
    slot-scope="props"
  >
    <tr>
      <td @click="$router.push('/accounts/' + props.item.id)" class="text-xs-center">
        <v-list-tile-avatar>
          <img :alt="$t('avatar')" :src="apiUrl + props.item.avatar" v-if="props.item.avatar"/>
          <img :alt="$t('avatar')" src="../../../assets/images/NoImage.png" v-else/>
        </v-list-tile-avatar>
      </td>
      <td @click="$router.push('/accounts/' + props.item.id)" class="text-xs-left">
        <span>{{ props.item.name}}</span>
      </td>
      <td class="text-xs-left">
        <span> {{props.item.email}}</span>
      </td>
      <td class="text-xs-left">
        <span> {{props.item.phone}}</span>
      </td>
      <td class="text-xs-left">
        <span>{{ props.item.date | moment('DD.MM.YYYY') }}</span>
      </td>
      <td class="d-flex justify-space-around">
        <v-icon @click="approveUser(props.item, true)" color="green" flat
                v-bind:class="[props.item.status != 1 ? 'gray' : '']">check_circle
        </v-icon>
        <v-icon @click="approveUser(props.item, false)" color="orange" flat
                v-bind:class="[props.item.status != 2 ? 'gray' : '']">block
        </v-icon>
        <v-icon @click="deleteModal(props.item)" color="red" flat>remove_circle</v-icon>
        <v-icon class="cursor-pointer" v-bind:style="props.item.status === 3 ? 'color:  orange;' : 'grey'">info</v-icon>
        <v-list-tile-action>
          <v-btn class="accept-btn mt-2" @click.prevent="confirmCompany(props.item)">
            {{$t('products.accept')}}
            <img src="../../../assets/images/confirm.svg" alt="confirm">
          </v-btn>
        </v-list-tile-action>
      </td>
    </tr>
    <v-dialog max-width="500px" v-model="dialog">
      <v-card>
        <v-card-title>
          <span class="headline">{{$t('settings.delete_company')}}</span>
        </v-card-title>
        <v-card-text>
          <v-flex>
            <p class="p-14">{{$t('settings.delete_company_text')}}</p>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="closeModal" class="g-btn-default g-btn-135 m-0-5">{{$t('settings.cancel')}}
          </v-btn>
          <v-btn @click.native="deleteUser" class="g-btn-main-light g-btn-135 m-0-5">{{$t('settings.delete')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  </v-data-table>
</div>
</template>

<script>

export default {
  name: 'AllCompanies',
  data: () => ({
    apiUrl: process.env.ROOT_API,
    companies: [],
    dialog: false
  }),
  methods: {
    confirmCompany (item) {
      let data = {
        id: item.id
      }
      this.$store.dispatch('auth/updateCompanyStatus', data).then((res) => {
        item.status = res.company.status
        this.$toastr(res.type, res.message, this.$t(res.type))
      }).catch(console.error)
    },
    getCompanies () {
      this.$store.dispatch('auth/getCompanies').then((res) => {
        res.companies.forEach(company => {
          this.companies.push({
            id: company.id,
            name: company.firstName,
            avatar: company.image,
            email: company.email,
            phone: company.phoneNumber,
            date: company.createdAt,
            status: company.status
          })
        })
      }).catch(console.error)
    },
    deleteModal (item) {
      this.deleteItem = item
      this.dialog = true
    },
    closeModal () {
      this.dialog = false
    },
    deleteUser () {
      if (this.deleteItem) {
        this.dialog = false
        const index = this.companies.indexOf(this.deleteItem)
        this.$store.dispatch('profile/deleteUser', this.deleteItem.id).then((res) => {
          if (res) {
            this.companies.splice(index, 1)
            this.$toastr(res.type, res.message, this.$t(res.type))
          }
        }).catch(console.error)
      }
    },
    approveUser (item, approve) {
      let approveData = {
        id: item.id,
        approve: approve
      }
      this.$store.dispatch('profile/approveUser', approveData).then((res) => {
        if (res) {
          item.status = approve ? 1 : 2
          this.$toastr(res.type, res.message, this.$t(res.type))
        }
      }).catch(console.error)
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('settings.companies'), value: 'avatar', sortable: false },
        { text: this.$t('settings.name'), align: 'left', sortable: true, value: 'name' },
        { text: this.$t('settings.email'), align: '', value: 'email', sortable: false },
        { text: this.$t('settings.phone'), align: '', value: 'phone', sortable: false },
        { text: this.$t('settings.date'), value: 'date' },
        { text: this.$t('settings.actions'), align: 'center', value: 'actions', sortable: false }

      ]
    }
  },
  created () {
    this.getCompanies()
  },
  mounted () {
    this.$refs.allCompanies.$el.querySelector('.v-table__overflow').addEventListener('touchstart', function (ev) {
      ev.stopPropagation()
    })
    this.$refs.allCompanies.$el.querySelector('.v-table__overflow').addEventListener('touchend', function (ev) {
      ev.stopPropagation()
    })
  }
}
</script>

<style scoped>
  .gray {
    opacity: 0.5;
    color: grey !important;
  }
  .accept-btn {
    border-radius: 21px;
    width: 116px;
    height: 30px;
    color: white;
    background-color: #5a65db!important;
    font-size: 12px;
    margin-left: 12px;
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/profilePage/components/AllCompanies.vue